import * as React from 'react';
import RadioList from 'components/Radio/RadioList';
import StringWidget from 'components/StringWidget/StringWidget';
import { get, isEmpty } from 'lodash';
import { getGrandTotalFormatted } from 'utils/paymentHelper';
import { connect } from 'react-redux';
import { PAYMENT_MODE } from 'pages/PaymentsPage/PaymentOptions/constants';
import InlineOfferMessage from 'pages/PaymentsPage/PaymentOptions/InlineOfferMessage';
import { getEligibleList } from 'pages/PaymentsPage/getEligibleList';
import { updateAdjustments } from 'actions/PaymentActions/EMIonSavedCardActions';
import { trackEMIOnSavedCardsShown } from 'pages/PaymentsPage/Analytics/PaymentsOmnitureHelper';
import { isSuccess, isLoading } from 'utils/asyncStatusHelper';
import styles from './OnSavedCardOptions.css';
export const getEMIInstrumentCheck = ({ instrumentCheck, paymentMode = PAYMENT_MODE.EMI_PAYMENT }) => {
    if (isEmpty(instrumentCheck)) {
        return {};
    }
    if (paymentMode === PAYMENT_MODE.EMI_PAYMENT) {
        return instrumentCheck[PAYMENT_MODE.EMI_PAYMENT] || {};
    }
    return instrumentCheck;
};
class EMIOnSavedCardOptions extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = (id) => {
            const { updateAdjustments, instrumentCheck } = this.props;
            const adjustments = get(getEMIInstrumentCheck({ instrumentCheck, paymentMode: id }), 'adjustments', {});
            this.setState({ checked: id }, () => {
                this.props.onUpdatePaymentMode(id);
                updateAdjustments(adjustments);
            });
        };
        this.state = {
            checked: props.defaultSelected || PAYMENT_MODE.FULL_PAYMENT
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const oldIc = this.props.instrumentCheck;
        const newIc = nextProps.instrumentCheck;
        if (isSuccess(newIc) && isLoading(oldIc)) {
            const instrumentCheck = newIc;
            const paymentModes = instrumentCheck.payment_modes || [];
            if (paymentModes.length > 1) {
                const emiIC = getEMIInstrumentCheck({ instrumentCheck });
                const emiAdjustmentList = get(emiIC, 'adjustments.adjustment_list', []);
                const message = InlineOfferMessage({ eligibleList: emiAdjustmentList, applied: true });
                trackEMIOnSavedCardsShown(Boolean(message));
            }
        }
    }
    render() {
        const { instrumentCheck, grandTotal } = this.props;
        if (!instrumentCheck)
            return null;
        const { checked } = this.state;
        const paymentModes = instrumentCheck.payment_modes;
        // This component is made to show two options always, so add this
        // explicit check. Once Bajaj FinServ card changes are worked on, this
        // assumption might change.
        if (!paymentModes || paymentModes.length !== 2) {
            return null;
        }
        const emiIC = getEMIInstrumentCheck({ instrumentCheck });
        const emiDisplayText = get(emiIC, 'adjustments.emi_display_text', '');
        // TODO: perhaps move this into getEligibleList function?
        const emiAdjustmentList = get(emiIC, 'adjustments.adjustment_list', []);
        const adjustmentList = getEligibleList({ instrumentCheck });
        return (<div className={styles['selection']}>
				<StringWidget strKey="emiOnSavedCardsTitle" className={styles['title']}/>
				<RadioList name="emi-on-saved-card" onChange={this.handleChange} checkedId={checked}>
					<div className={styles['option']} key={PAYMENT_MODE.FULL_PAYMENT}>
						<StringWidget strKey={'emiOnSavedCardsPayFullAmount'} attributes={{ fullAmount: grandTotal }}/>
						<InlineOfferMessage eligibleList={adjustmentList} applied={checked === PAYMENT_MODE.FULL_PAYMENT} className={styles['inline-offer']} messageClassName={styles['inline-offer-message']}/>
					</div>
					{emiDisplayText ? (<div className={styles['option']} key={PAYMENT_MODE.EMI_PAYMENT}>
							<StringWidget strKey={'emiOnSavedCardsPayEMI'} attributes={{ message: emiDisplayText }}/>
							<InlineOfferMessage eligibleList={emiAdjustmentList} applied={checked === PAYMENT_MODE.EMI_PAYMENT} className={styles['inline-offer']} messageClassName={styles['inline-offer-message']}/>
						</div>) : null}
				</RadioList>
			</div>);
    }
}
const mapStateToProps = (state, ownProps) => {
    const instrumentCheck = getEMIInstrumentCheck({
        instrumentCheck: ownProps.instrumentCheck,
        paymentMode: PAYMENT_MODE.FULL_PAYMENT
    });
    const adjustments = get(instrumentCheck, 'adjustments', {});
    const grandTotal = getGrandTotalFormatted(state.payments.paymentOptions, adjustments);
    return { grandTotal };
};
const mapDispatchToProps = {
    updateAdjustments
};
const ConnectedEMIOnSavedCardOptions = connect(mapStateToProps, mapDispatchToProps)(EMIOnSavedCardOptions);
export { ConnectedEMIOnSavedCardOptions as EMIOnSavedCardOptions };
